import * as React from 'react';
import styled from 'styled-components';
import {Formik, Form as FormContainer} from 'formik';
import InputContainer from 'containers/InputContainer';
import {TagBuilder} from 'components/TagBuilder';
import {FolderSelector} from 'components/FolderSelector';
import * as Forms from './forms';
import {Folder, Tag} from 'types';
import {WebinarObject} from 'api/webinar/types';
import WebinarBuilderContext from '../../CourseBuilderContext';
import {
  AfterPlugForm,
  BeforePlugForm,
  PrepareMessageForm,
  SummaryForm,
} from './forms';

const Form = styled(FormContainer)`
  row-gap: 10px;
  display: grid;
`;

const TagsContainer = styled.div`
  margin-bottom: 20px;
`;

/**
 * The webinar content
 * @return {React.ReactElement}
 * @constructor
 */
export default function Content(): React.ReactElement {
  const {
    webinar,
    setWebinar,
  } = React.useContext(WebinarBuilderContext);

  const initialValues: Partial<WebinarObject> = {
    ...webinar,
  };

  console.log(webinar);

  /**
   * Render folders.
   * @return {JSX.Element}
   */
  function renderFolders(): JSX.Element {
    /**
     * The change event handler.
     */
    function handleChange(folders: Folder[]): void {
      setWebinar && setWebinar({
        ...webinar,
        folders,
      })
    }

    return (
      <TagsContainer>
        <InputContainer label="Папки">
          <FolderSelector
            type="webinars"
            folders={webinar?.folders}
            onChange={handleChange}
            creatable
          />
        </InputContainer>
      </TagsContainer>
    );
  }

  /**
   * Render tags.
   * @return {JSX.Element}
   */
  function renderTags(): JSX.Element {
    /**
     * The change event handler.
     */
    function handleChange(tags: Tag[]): void {
      setWebinar && setWebinar({
        ...webinar,
        tags,
      })
    }

    return (
      <TagsContainer>
        <InputContainer label="Теги">
          <TagBuilder
            type="webinars"
            tags={webinar?.tags}
            onChange={handleChange}
          />
        </InputContainer>
      </TagsContainer>
    );
  }

  /**
   * Handle form submit
   * @param {Partial<WebinarObject>} settings
   */
  function handleSubmit(settings: Partial<WebinarObject>): void {
    setWebinar && setWebinar({
      ...webinar,
      ...settings,
    });
  }

  return (
    <React.Fragment>
      {renderFolders()}
      {renderTags()}
      <Formik<Partial<WebinarObject>>
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <Forms.ContentTypeForm />
            <Forms.DateForm />
            <Forms.RecordTimeForm />
            <Forms.SaveAfterForm />
            <Forms.BeforePlugForm />
            <Forms.AfterPlugForm />
            <Forms.PrepareMessageForm />
            <Forms.SummaryForm />
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}
